/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spec_Details_ExtractedInputs */

const en_spec_details_extracted = /** @type {(inputs: Spec_Details_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spec Details Extracted`)
};

const es_spec_details_extracted = /** @type {(inputs: Spec_Details_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles de especificación extraídos`)
};

const fr_spec_details_extracted = /** @type {(inputs: Spec_Details_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails des spécifications extraits`)
};

const de_spec_details_extracted = /** @type {(inputs: Spec_Details_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spezifikationsdetails extrahiert`)
};

const ja_spec_details_extracted = /** @type {(inputs: Spec_Details_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仕様詳細が抽出されました`)
};

const zh_spec_details_extracted = /** @type {(inputs: Spec_Details_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已提取规格详情`)
};

const ar_spec_details_extracted = /** @type {(inputs: Spec_Details_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم استخراج تفاصيل المواصفات`)
};

const id_spec_details_extracted = /** @type {(inputs: Spec_Details_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail Spesifikasi Diekstrak`)
};

const it_spec_details_extracted = /** @type {(inputs: Spec_Details_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dettagli delle Specifiche Estratti`)
};

const ru_spec_details_extracted = /** @type {(inputs: Spec_Details_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Детали спецификации извлечены`)
};

const pt_spec_details_extracted = /** @type {(inputs: Spec_Details_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhes de Especificação Extraídos`)
};

const ko_spec_details_extracted = /** @type {(inputs: Spec_Details_ExtractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사양 세부 정보 추출됨`)
};

/**
* | output |
* | --- |
* | "Spec Details Extracted" |
*
* @param {Spec_Details_ExtractedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const spec_details_extracted = /** @type {((inputs?: Spec_Details_ExtractedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spec_Details_ExtractedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_spec_details_extracted(inputs)
	if (locale === "es") return es_spec_details_extracted(inputs)
	if (locale === "fr") return fr_spec_details_extracted(inputs)
	if (locale === "de") return de_spec_details_extracted(inputs)
	if (locale === "ja") return ja_spec_details_extracted(inputs)
	if (locale === "zh") return zh_spec_details_extracted(inputs)
	if (locale === "ar") return ar_spec_details_extracted(inputs)
	if (locale === "id") return id_spec_details_extracted(inputs)
	if (locale === "it") return it_spec_details_extracted(inputs)
	if (locale === "ru") return ru_spec_details_extracted(inputs)
	if (locale === "pt") return pt_spec_details_extracted(inputs)
	return ko_spec_details_extracted(inputs)
});